import { render, staticRenderFns } from "./courseClasses.vue?vue&type=template&id=2e8504e2&scoped=true"
import script from "./courseClasses.vue?vue&type=script&lang=js"
export * from "./courseClasses.vue?vue&type=script&lang=js"
import style0 from "./courseClasses.vue?vue&type=style&index=0&id=2e8504e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8504e2",
  null
  
)

export default component.exports